export default __webpack_public_path__ + "static/media/chihuahuas.e297d067.png";